import { faThumbTack } from "@fortawesome/pro-regular-svg-icons";
import { faThumbTack as faThumbTackSolid } from "@fortawesome/pro-solid-svg-icons";
import { twJoin } from "tailwind-merge";

import { Icon } from "src/design-system/Icon";
import { Tooltip } from "src/design-system/Tooltip";

type PinButtonProps = {
  pinned: boolean;
  onChange: (pinned: boolean) => void;
  dataLoc?: string;
};

export const PinButton: React.FC<PinButtonProps> = ({
  pinned,
  onChange,
  dataLoc,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onChange(!pinned);
  };

  const dataLocPostfix = pinned ? "pinned" : "unpinned";

  return (
    <div
      className={twJoin(
        "flex cursor-pointer items-center justify-center rounded p-1 hover:bg-gray-100",
        pinned ? "opacity-100" : "opacity-0 group-hover:opacity-100",
      )}
      data-loc={dataLoc ? `${dataLoc}-${dataLocPostfix}` : undefined}
      role="button"
      onClick={handleClick}
    >
      <Tooltip delay={500} title={`${pinned ? "Unpin" : "Pin"} item`} asChild>
        <Icon
          icon={pinned ? faThumbTackSolid : faThumbTack}
          size="xs"
          variant={pinned ? "active" : "default"}
        />
      </Tooltip>
    </div>
  );
};
